import React, { useEffect, useState } from "react";
import Joi from "joi"
const AddressForm  = (props)=>{
     
    const [address,setAddress] = useState({})
    const [loading,setLoading] = useState(false)
    const states = [
        "Andhra Pradesh (AP)",
       " Arunachal Pradesh (AR)",
        "Assam (AS)",
      "  Bihar (BR)",
       " Chhattisgarh (CG)",
        "Goa (GA)",
       " Gujarat (GJ)",
      "  Haryana (HR)",
       " Himachal Pradesh (HP)",
      "  Jammu and Kashmir (JK)",
       " Jharkhand (JH)",
      "  Karnataka (KA)",   
       " Kerala (KL)",
      "  Madhya Pradesh (MP)",
       " Maharashtra (MH)",
       " Manipur (MN)",
      "  Meghalaya (ML)",
       " Mizoram (MZ)",
       " Nagaland (NL)",
       " Odisha(OR)",
        "Punjab (PB)",
        "Rajasthan (RJ)",
      "  Sikkim (SK)",
       " Tamil Nadu (TN)",
       " Telangana (TS)",
      "  Tripura (TR)",
      "  Uttar Pradesh (UP)",
       " Uttarakhand (UK)",
       " West Bengal (WB)",
    ]
    useEffect(()=>{
        if(props.address){
            setAddress(props.address)
        }else{
            setAddress({state:states[0],country:"India"})
        }
        if(props.setAddress){
            props.setAddress({state:states[0],country:"India"})
        }
    },[])
    const handleChange = (e)=>{
        let {name,value} = e.target
        let addressObj = {...address};
       
        addressObj[name] = value;
        setAddress(addressObj)
        if(props.setAddress){
            props.setAddress(addressObj)
        }
    }
    const handleFormSubmit = async (e)=>{
    try{

        e.preventDefault()
        let {error} = schema.validate(address);
        if(error){
            return alert(error)
        }else{
            setLoading(true)
            //Submit form code
            await props.editAddress(address,props.user)
            setLoading(false)
            props.setModal(false)
            window.location.reload(false)
        }

    }catch(error){

        return alert(error)

    }
       

    }

    const schema = Joi.object({
        id:Joi.string(),
        firstname:Joi.string().trim().max(20).required(),
        lastname:Joi.string().trim().max(30).required(),
        emailaddress:Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net','in'] } }).required(),
        country:Joi.string().required(),
        streetaddress:Joi.string().trim().max(100).required(),
        landmark:Joi.string().trim().max(50).required(),
        state:Joi.string().required(),
        city:Joi.string().trim().required().max(30),
        pincode:Joi.string().trim().min(6).max(6).required(),
        phone:Joi.string().trim().min(10).max(10).required(),
        businessname:Joi.string().trim().max(40),
        businessgst:Joi.string().trim().max(50)

    })

    return(
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="row" >
                    <div className="form-group col-sm-12 col-md-6" >
                        <label htmlFor="firstname" >First Name </label>
                        <input onChange={handleChange} name="firstname" value={address.firstname}   className="form-control form-control-sm" required id="firstname"  />
                    </div>
                    <div className="form-group col" >
                        <label htmlFor="lastname" >Last Name </label>
                        <input onChange={handleChange} name="lastname" value={address.lastname} className="form-control form-control-sm" required id="lastname" />
                    </div>
                </div>


                <div className="row" >
                    <div className="form-group col-sm-12 col-md-6" >
                        <label htmlFor="emailaddress" >Email Address </label>
                        <input  onChange={handleChange} name="emailaddress" value={address.emailaddress} type="email" id="emailaddress" required className="form-control form-control-sm" />
                    </div>
                    <div className="form-group col" > 
                        <label htmlFor="country" >Country  </label>
                        <label id="country" className="form-control form-control-sm border-0"  ><strong>India</strong></label>
                    </div>
                </div>


                <div className="row" >
                    <div className="form-group col-sm-12 col-md-6" >
                        <label htmlFor="streetaddress" >Street Address </label>
                        <input onChange={handleChange} name="streetaddress" value={address.streetaddress} id="streetaddress" required className="form-control form-control-sm" />
                    </div>
                    <div className="form-group col" > 
                        <label htmlFor="landmark" >Landmark  </label>
                        <input onChange={handleChange} name="landmark" value={address.landmark} id="landmark" required className="form-control form-control-sm" />
                    </div>
                </div>

                <div className="row" > 
                    <div className="form-group col-sm-12 col-md-6" >
                        <label htmlFor="state" >State </label>
                        <select className="form-control form-control-sm" id="state"
                            onChange={handleChange}
                            name="state"
                            required
                            value={address.state}
                        >
                            {states.map(state=>(
                                <option value={state} key={state}>{state}</option>
                            ))}
                        </select>
                       
                    </div>
                    <div className="form-group col" > 
                        <label htmlFor="city" >Town / City  </label>
                        <input onChange={handleChange} name="city" value={address.city} id="city" required className="form-control form-control-sm" />
                    </div>
                </div>

                <div className="row" >
                    <div className="form-group col-sm-12 col-md-6" >
                        <label htmlFor="pincode" >Pincode / ZIP </label>
                        <input onChange={handleChange} name="pincode" value={address.pincode} type="number" pattern="[0-9]{6}" id="pincode" required className="form-control form-control-sm" />
                    </div>
                    <div className="form-group col" > 
                        <label htmlFor="phone" >Phone No(+91)  </label>
                        <input onChange={handleChange} name="phone" value={address.phone} type="tel" id="phone" required className="form-control form-control-sm" />
                    </div>
                </div>

                <label><strong>Business Details</strong></label>
                <div className="row" >
                    <div className="form-group col-sm-12 col-md-6" >
                        <label htmlFor="businessname" >Business Name</label>
                        <input onChange={handleChange} name="businessname" value={address.businessname} id="businessname"  className="form-control form-control-sm" />
                    </div>
                    <div className="form-group col" > 
                        <label htmlFor="businessgst" >Business Gst </label>
                        <input onChange={handleChange} name="businessgst" value={address.businessdetails} id="businessgst"   className="form-control form-control-sm" />
                    </div>
                </div>
              {!props.setAddress&&(<div className="text-center">
              <button className="btn btn-primary btn-sm" type="submit" disabled={loading} >
                  {
                      loading?"Submitting":"Submit"
                  }
                  </button>
              </div>)}
              {
                  props.showSubmit&&(<div className="text-center">
                  <button className="btn btn-primary btn-sm" type="submit" disabled={loading} >
                      {
                          loading?"Submitting":"Submit"
                      }
                      </button>
                  </div>)
              }
            </form>
        </div>
    )
}

export default AddressForm